import { stringify } from "querystringify"

import { ClientDiscount, ErrorResponse } from "utils/interfaces"
import { httpClient, toAxiosError } from "utils/infrastructure/httpClient"

export const getDiscounts = (offered_service_id?: number, booking_id?: number, date?: string) => {
    return httpClient.get<ClientDiscount[]>(
        `client/discount${stringify(
            {
                ...(offered_service_id && { offered_service_id }),
                ...(booking_id && { booking_id }),
                ...(date && { date }),
            },
            "?"
        )}`,
        {}
    )
}

export const saveDiscount = async (promoCode: string) => {
    try {
        const data = await httpClient.post<{ discount_id: number }>(
            "pricing/discount/save-promo-code",
            {
                discount: promoCode,
            }
        )
        return { discountId: data.discount_id, error: undefined }
    } catch (e) {
        return {
            discountId: undefined,
            error: toAxiosError<ErrorResponse>(e)?.response?.data.error,
        }
    }
}
